export default {
  computed: {
    dashboard() {
      if (this.dashboardId) {
        return this.$store.getters['dashboards/get'][this.dashboardId];
      }
      return this.$store.getters['dashboards/menuDefaultDashboard'];
    },
    dashboardIds() {
      return this.$store.getters['dashboards/lastVisitedId'];
    },
    dashboardId() {
      return this.dashboardIds[this.dashboardIds.length - 1];
    },
    isDashboardGroup() {
      const lastDashboardIds = this.$store.getters['dashboards/lastVisitedId'];
      return Array.isArray(lastDashboardIds) && lastDashboardIds.length > 1;
    },
    nav() {
      const navigationItemsList = Object.values(this.$store.getters['navigationItems/navigationItems']);
      if (this.isDashboardGroup) {
        return navigationItemsList.find(navItem => navItem.resourceId === this.dashboardIds[0] && navItem.resourceType === 'NavigationGroup')?.query;
      }
    },
  },
  methods: {
    tagWithModal(statusId, keepGoingRoute) {
      this.createFlashcardState({ flashcardStatusId: statusId });
      let finishedRoute;
      if (this.isDashboardGroup) {
        finishedRoute = {
          name: 'dashboard#group',
          params: {
            dashboardId: this.dashboardId,
            navigationGroupId: this.dashboardIds[0],
          },
          query: {
            nav: this.nav,
          },
        };
      } else if (this.dashboardId) {
        finishedRoute = { name: 'dashboard#show', params: { dashboardId: this.dashboardId }};
      }
      if (!keepGoingRoute) {
        keepGoingRoute = { name: 'categories#flashcard', categoryId: this.currentFlashcardCategory.id };
      }
      this.$modal.show('qotd-modal', {correct: this.correct, keepGoingRoute: keepGoingRoute, finishedRoute: finishedRoute});
    },
  },
};
